import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { BqDialog, BqIcon } from '@beeq/react'
import { Text } from '../../../constants/TextConstants'
import { StyledTitle, StyledSection, StyledSectionItem, StyledSectionItemRow } from './styles'
import { isSystemRole } from '../../../utils/utils'

/**
 * @typedef {Object} ViewRoleProps
 * @property {boolean} open
 * @property {import('../../Modals/CreateRole').Role?} role
 * @property {import('../../Modals/CreateRole').Permission[]} permissions
 * @property {() => void} onClose
 */

/**
 * @param {ViewRoleProps} props
 * @returns {import('react').ReactElement}
 */
export default function ViewRole({ open, onClose, role, permissions }) {
  const activePermissions = useMemo(() => {
    if (!role || !permissions) {
      return []
    }
    return permissions.filter(({ _id }) => role.permissions.includes(_id))
  }, [permissions, role])

  return (
        <BqDialog open={open} onBqClose={onClose} onBqCancel={onClose}>
            <StyledTitle className="h5 bold" slot="title"><BqIcon name="info" weight="bold" size={30} />{Text.ViewRoleTitle}</StyledTitle>
            <StyledSection>
                <StyledSectionItem>
                    <span className='caption'>{Text.Role}</span>
                    <strong>{role?.name}</strong>
                </StyledSectionItem>
                <StyledSectionItem>
                    <span className='caption'>{Text.ActivePermissionsLabel}</span>
                    {activePermissions.map((permission) =>
                        <StyledSectionItemRow key={permission._id} className="caption medium" >
                            <BqIcon name="check-circle" weight="bold" />
                            {permission.label}
                        </StyledSectionItemRow>
                    )}
                </StyledSectionItem>
                {role && !isSystemRole(role.name) &&
                    <StyledSectionItem>
                        <span className='caption'>{Text.RoleCreatedBy}</span>
                        <span className='caption medium'>{role.createdBy}</span>
                    </StyledSectionItem>}
            </StyledSection>
        </BqDialog>
  )
}

ViewRole.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  role: PropTypes.shape(PropTypes.object),
  permissions: PropTypes.arrayOf(PropTypes.object).isRequired

}
